var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmergencyHelpClick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_597_4657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1357 28.7605L16.7546 39.8143C15.8902 40.307 14.8416 39.5627 15.0215 38.5844L15.8292 34.1844L6.44081 34.8395C5.79544 34.8839 5.23543 34.3968 5.19051 33.7521L4.65074 26.0037C4.60634 25.3583 5.09341 24.7983 5.73819 24.7534L15.1276 24.0982L13.7178 19.8537C13.4039 18.9098 14.3398 18.0278 15.2637 18.3954L35.9889 26.6531C36.898 27.0162 36.9884 28.2741 36.1357 28.7605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6384 22.1396C42.1268 22.5643 42.867 22.5128 43.2917 22.0244L46.3314 18.5295C46.7561 18.0412 46.7046 17.301 46.2163 16.8762C45.7279 16.4515 44.9877 16.5031 44.563 16.9914L41.5233 20.4863C41.0986 20.9746 41.1501 21.7148 41.6384 22.1396Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3564 32.4518C41.9317 32.9402 41.9833 33.6804 42.4716 34.1051L45.9661 37.1445C46.4544 37.5692 47.1947 37.5176 47.6194 37.0293C48.0441 36.541 47.9925 35.8007 47.5042 35.376L44.0097 32.3367C43.5214 31.912 42.7812 31.9635 42.3564 32.4518Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6971 19.1401C34.7411 19.7848 35.2994 20.2735 35.9461 20.2294C36.5918 20.1853 37.0794 19.626 37.0354 18.9804L36.7199 14.3595C36.6758 13.7138 36.1165 13.2261 35.4709 13.2702C34.8252 13.3143 34.3375 13.8735 34.3816 14.5192L34.6971 19.1401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3059 28.0905L49.9267 27.7744C50.5724 27.7302 51.0601 27.171 51.0158 26.5253C50.9717 25.8795 50.4124 25.3919 49.7667 25.4362L45.1459 25.7522C44.5002 25.7964 44.0126 26.3556 44.0568 27.0013C44.1011 27.6478 44.661 28.1346 45.3059 28.0905Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1908 41.0043C36.235 41.6497 36.7937 42.1378 37.4398 42.0936C38.0855 42.0495 38.5732 41.4903 38.5291 40.8446L38.2135 36.2238C38.1694 35.578 37.6102 35.0905 36.9645 35.1345C36.3188 35.1786 35.8311 35.7379 35.8752 36.3835L36.1908 41.0043Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_597_4657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(26.813) rotate(41.0151)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyHelpClick);
export default __webpack_public_path__ + "static/media/EmergencyHelpClick.7e8e472a64c06127774dd80ec30b4137.svg";
export { ForwardRef as ReactComponent };